/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDepartment.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const AutogenUserSavedSearchEndpoint = "lme/general/department";

export class AutogenModelDepartment<RowType extends ModelRow> extends Endpoint<RowType, RowDepartmentFields> {
    constructor(ctor: RowConstructor) {
        super(AutogenUserSavedSearchEndpoint, ctor);
    }
}

export class AutogenRowDepartment extends ModelRow<RowDepartmentFields> {
    constructor() {
        super(AutogenUserSavedSearchEndpoint);
    }
}

export interface RowDepartmentFields {
    company_id: string;
    descr: string;
    id: string;
}

